import { getMedia } from "../data/mediaRegistry";

const SITE = "https://timefurniture.ae";

// Accurate VideoObject schema for a registry key. No invented view counts.
export function videoJsonLd({ key, name, description, seconds = 10, uploadDate = "2026-10-01" }) {
  const m = getMedia(key);
  if (!m || !m.video) return null;
  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name,
    description,
    thumbnailUrl: [`${SITE}${m.poster}`],
    contentUrl: `${SITE}${m.video}`,
    uploadDate,
    duration: `PT${seconds}S`,
  };
}
